<template>
  <div class="scan-info-details">
    <div>操作类型：<span class="scan-type-text">{{scanType|showLabel(rfidConfig.allScanTypes,null,true)}}</span></div>
    <div>
      <el-form inline>
        <el-form-item>
          <el-select v-model="heapNumber" @change="heapNumberChanged" clearable placeholder="请选择"
                     @clear="heapNumberChanged"
                     v-show="heapList.length">
            <el-option
              v-for="item in heapList"
              :key="item.u_name"
              :value="item.id"
              :label="`堆号：${item.u_name}`"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span class="scan-info-heap-process"
                v-show="heapList.length&&u_count>=0&&currentSelectItem.u_MaxCount>=0">{{u_count}}/{{currentSelectItem.u_MaxCount}}</span>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div v-if="totalCount">扫描数量 <span class="scan-type-text">{{heapCount}}/{{totalCount}}</span></div>
      <div v-else>扫描数量 <span class="scan-type-text">{{scanCount}}</span></div>
    </div>
  </div>
</template>

<script>
  import RfidEditConfig from "@/views/rfid/RfidEditConfig";
  import {showLabel} from "@/utils";
  import Enumerable from "linq";

  export default {
    filters: {
      showLabel: showLabel,
    },
    props: ['scanType', 'scanCount', 'totalCount', 'heapList', 'u_count'],
    name: "ScanInfoDetails",
    data() {
      return {
        heapTotalCount: 2000,
        heapNumber: '',
        rfidConfig: RfidEditConfig,
        currentSelectItem: {},
      }
    },
    methods: {
      heapNumberChanged(val) {
        if (val) {
          var item = Enumerable.from(this.heapList).first(fx => fx.id == val);
          if (item) {
            this.currentSelectItem = item;
            this.$emit('heapNumberChanged', item);
          } else {
            this.$emit('heapNumberChanged', undefined);
          }
        } else {
          this.$emit('heapNumberChanged', undefined);
        }
      },
      clearHeap() {
        this.currentSelectItem = {};
        this.heapNumber = '';
      }
    }
  }
</script>

<style scoped lang="less">
  @import "./rfid";

  .scan-info-heap-process {
    font-size: 18pt;
    color: #ff4949;
    font-weight: bold;
  }
</style>
